var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-layout',{staticClass:"sidebarTop"},[_c('v-flex',{attrs:{"align-self-center":""}},[_c('h4',[_vm._v("Título geral")]),_c('p',[_vm._v("22/04/2020")])])],1),_c('v-layout',{staticClass:"sidebarCenter"},[_c('v-flex',[_c('h4',[_vm._v("Sibtítulo geral")])])],1),_c('v-layout',{staticClass:"sidebarBottom"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }